import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'

const query = `
  query ShopInfo {
    shop {
      contactEmail
      currencyCode
    }
  }
`

const doFetchShopInfo = integrationId => dispatch => {
  return dispatch(
    doGraphqlRequest(
      types.FETCH_SHOP_INFO_REQUEST,
      query,
      {},
      {
        graphqlFunc: graphql(integrationId),
      }
    )
  )
}

export default doFetchShopInfo
